import React from "react";
const Edelicon = (props) => {
    var _a;
    return (React.createElement("i", { className: props === null || props === void 0 ? void 0 : props.className, onClick: () => (props === null || props === void 0 ? void 0 : props.onClick) && (props === null || props === void 0 ? void 0 : props.onClick()) }, Array.from({ length: (_a = props === null || props === void 0 ? void 0 : props.paths) !== null && _a !== void 0 ? _a : 0 }, (_, index) => (React.createElement("span", { key: index, className: `path${index + 1}` })))));
};
export default Edelicon;
